// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #1B285E;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 105px;
}

.toolbar {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
}

.left-section {
  display: flex;
  align-items: center;
}

.logos-container {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-right: 48px;
}

.rafap-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.lead-logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 32px;
}

.nav-link {
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;
  font-family: "Trasandina Web", Trasandina, sans-serif;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #FDBD10;
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

.nav-link.active::after {
  width: 100%;
}

.right-section {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.user-menu {
  position: relative;
}

.avatar {
  width: 40px !important;
  height: 40px !important;
  border: 2px solid #FDBD10 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  background-color: #FDBD10 !important;
  color: #1B285E !important;
  font-family: "Trasandina", sans-serif !important;
  font-weight: 600 !important;
  font-size: 1.2rem !important;
}

.avatar:hover {
  border-color: #ffcd3c !important;
  background-color: #ffcd3c !important;
  transform: scale(1.05) !important;
}

.menu-button {
  display: none;
}

/* Ajuste para el contenido principal */
.page-container {
  padding-top: 125px; /* header height (105px) + 20px de espacio */
  padding: 125px 32px 32px 32px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-title {
  color: #1B285E;
  font-family: "Trasandina Web", Trasandina, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 24px;
}

@media (max-width: 1024px) {
  .nav-links {
    display: none;
  }
  
  .menu-button {
    display: block;
    margin-right: 16px;
  }
  
  .lead-logo {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,0BAA0B;EAC1B,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,gDAAgD;EAChD,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,kBAAkB,EAAE,4CAA4C;EAChE,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  background-color: #1B285E;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: 105px;\n}\n\n.toolbar {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n}\n\n.left-section {\n  display: flex;\n  align-items: center;\n}\n\n.logos-container {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-right: 48px;\n}\n\n.rafap-logo {\n  height: 50px;\n  width: auto;\n  object-fit: contain;\n}\n\n.lead-logo {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.nav-link {\n  color: #ffffff;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 8px 0;\n  position: relative;\n  transition: all 0.3s ease;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background-color: #FDBD10;\n  transition: width 0.3s ease;\n}\n\n.nav-link:hover::after {\n  width: 100%;\n}\n\n.nav-link.active::after {\n  width: 100%;\n}\n\n.right-section {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n\n.user-menu {\n  position: relative;\n}\n\n.avatar {\n  width: 40px !important;\n  height: 40px !important;\n  border: 2px solid #FDBD10 !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  background-color: #FDBD10 !important;\n  color: #1B285E !important;\n  font-family: \"Trasandina\", sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 1.2rem !important;\n}\n\n.avatar:hover {\n  border-color: #ffcd3c !important;\n  background-color: #ffcd3c !important;\n  transform: scale(1.05) !important;\n}\n\n.menu-button {\n  display: none;\n}\n\n/* Ajuste para el contenido principal */\n.page-container {\n  padding-top: 125px; /* header height (105px) + 20px de espacio */\n  padding: 125px 32px 32px 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-title {\n  color: #1B285E;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 1024px) {\n  .nav-links {\n    display: none;\n  }\n  \n  .menu-button {\n    display: block;\n    margin-right: 16px;\n  }\n  \n  .lead-logo {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
